import { render, staticRenderFns } from "./Dorms.vue?vue&type=template&id=271ed4f8&scoped=true&"
import script from "./Dorms.vue?vue&type=script&lang=js&"
export * from "./Dorms.vue?vue&type=script&lang=js&"
import style0 from "./Dorms.vue?vue&type=style&index=0&id=271ed4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ed4f8",
  null
  
)

export default component.exports